import React, {} from "react"
import axios from 'axios';
import { logApiRequest } from '../mixpanelInterface';
import getGeoInfo from './getGeoInfo';

const paths = require('../../../paths.json');

export default function checkout_button(tier, influencer, data_func, duration) {
   var access_token = localStorage.getItem("fitwith_access_token");
   const startTime = performance.now();
   // get the current currency
   let currency = getGeoInfo(true, true)
   const queryString = window.location.search;
   const urlParams = new URLSearchParams(queryString);
   let promo_code = urlParams.get('promo_code')
   // No promo code set it to false
   if (!(!!promo_code)) {
      promo_code = false
   }
   axios(
      {
         method: 'get',
         url: paths.BACKEND_URL + "checkout/config/",
         headers: {
            'Content-type': 'application/json',
        },
        withCredentials: true
        }
    ).then((result) => {
        if (!result.data.access_denied) {
            // Initialize Stripe.js
            logApiRequest(paths.BACKEND_URL + "checkout/config/", performance.now() - startTime);
            const stripe = window.Stripe(result.data.publicKey);
            // new
            // Event handler
            // Get Checkout Session ID
            axios({
                method: 'get',
                url: paths.BACKEND_URL + "checkout/create-checkout-session/" + influencer + "/" + tier + "/" + duration + "/" + currency + "/" + promo_code,
                headers: {
                    'Content-type': 'application/json',
                },
                withCredentials: true,
                })
            .then((result) => {

               // Redirect to Stripe Checkout
               stripe.redirectToCheckout({sessionId: result.data.sessionId})
               this.setState({redirecting_to_checkout: false})
            })
            .catch(error => {
               window.location.href.includes('/login') ? 
               window.location.assign('/login?post_url='+influencer+'&mode=paid_sub&id='+tier+'&duration='+duration+'&promo_code='+promo_code) :
               window.location.assign('/register?post_url='+influencer+'&mode=paid_sub&id='+tier+'&duration='+duration+'&promo_code='+promo_code)
               this.setState({redirecting_to_checkout: false})
            });
        } else {
            this.setState({redirecting_to_checkout: false})
            throw new Error(result);
        }
    }).catch(error => {
      window.location.href.includes('/login') ? 
      window.location.assign('/login?post_url='+influencer+'&mode=paid_sub&id='+tier+'&duration='+duration+'&promo_code='+promo_code) :
      window.location.assign('/register?post_url='+influencer+'&mode=paid_sub&id='+tier+'&duration='+duration+'&promo_code='+promo_code)
      this.setState({redirecting_to_checkout: false})
    });
};
